import { useId, useState } from 'react'
import { moveFocus } from './moveFocus'
import type { ShellSelectOption } from './types'
import { polePopoverOverrides } from './styled-components'

export interface ShellSelectMenuItem extends ShellSelectOption {
  isSelected: boolean
  onChoose: () => void
}

interface UseShellSelectParams {
  options: ShellSelectOption[]
  selectedId?: string | null
  onSelect: (id: string) => void
  disabled: boolean
  variant: 'tile' | 'field'
}

const useShellSelect = ({ options, selectedId, onSelect, disabled, variant }: UseShellSelectParams) => {
  const [isOpen, setIsOpen] = useState(false)
  const labelId = useId()
  const selected = options.find(option => option.id === selectedId?.toString())

  const close = () => setIsOpen(false)

  const toggle = () => {
    if (!disabled) setIsOpen(open => !open)
  }

  const items: ShellSelectMenuItem[] = options.map(option => ({
    ...option,
    isSelected: option.id === selected?.id,
    onChoose: () => {
      setIsOpen(false)
      onSelect(option.id)
    },
  }))

  return {
    isOpen,
    labelId,
    isField: variant === 'field',
    hasSelection: selected !== undefined,
    selectedTitle: selected?.title,
    items,
    close,
    toggle,
    popoverOverrides: polePopoverOverrides,
    onMenuKeyDown: moveFocus('[role="option"]'),
  }
}

export default useShellSelect
